
let BASE_URL = "https://carinfo2.taplab.cn:1443"
// let BASE_URL = "http://192.168.0.112:8081"
// let BASE_URL = "http://127.0.0.1:8081"


export default {
    BASE_URL,
}